import React, { useEffect } from "react";
import STCommentList from "../../../../assets/styles/organisms/myPageCommentList.module.scss";
import CommentItem from "./CommentItem";
import { CircularProgress } from "@material-ui/core";
import { fetchMyBoardComments } from "../../../../utils/api/fetchMyBoardComment";
import { DataMyComments } from "../../../../api/board_comment";
import moment from "moment";
import { CheckSpFlag } from "../../../../hooks/CheckSpFlag";

interface CommentListProps {
  boardId: number;
  categoryId: number;
}

const CommentList: React.FC<CommentListProps> = ({ boardId, categoryId }) => {
  const [comments, setComments] = React.useState<DataMyComments[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isShowMore, setIsShowMore] = React.useState(true);
  const checkSpFlag = CheckSpFlag();

  useEffect(() => {
    fetchMyBoardComments({
      board_id: boardId,
    })
      .then((res) => {
        if (!res.data) return;
        setComments(res.data);
      })
      .catch((error) => {
        console.error("Error fetching comments:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });

    // fetchComments();
  }, [boardId]);

  const showMoreComments = () => {
    setIsShowMore((prev) => !prev);
  };

  const onUpdateSuccess = (newComment: any) => {
    setComments((prev) => {
      const updatedComments = prev.map((comment) => {
        if (comment.id === newComment.id) {
          return { ...comment, ...newComment };
        }
        return comment;
      });
      return updatedComments;
    });
  };

  const onDeleteSuccess = (deletedCommentId: number) => {
    setComments((prev) =>
      prev.filter((comment) => comment.id !== deletedCommentId)
    );
  };

  if (checkSpFlag && !comments.length) {
    return null;
  }
  return (
    <div
      className={STCommentList.commentList}
      onClick={(e) => e.stopPropagation()}
    >
      {isLoading ? (
        <div className={STCommentList.loadingContainer}>
          <CircularProgress
            color="inherit"
            size={25}
            disableShrink
            style={{ marginRight: 8 }}
          />
        </div>
      ) : comments.length === 0 ? (
        <div className={STCommentList.noCommentsContainer}>
          <span>あなたのコメントはありません</span>
          <div
            onClick={() => {
              window.location.href = `/message-board/categories/${categoryId}/${boardId}`;
            }}
          >
            コメントする
          </div>
        </div>
      ) : (
        <>
          {(isShowMore ? comments.slice(0, 2) : comments).map((comment) => (
            <CommentItem
              key={comment.id}
              boardId={boardId}
              detailComment={{
                id: comment.id,
                content: comment.content,
                createdAt: moment(comment.created_at).format("YYYY/MM/DD"),
                status: comment.status,
              }}
              onUpdateSuccess={onUpdateSuccess}
              onDeleteSuccess={onDeleteSuccess}
            />
          ))}
          {isShowMore && comments.length > 2 && (
            <span onClick={showMoreComments}>{`他${
              comments.length - 2
            }件`}</span>
          )}
        </>
      )}
    </div>
  );
};

export default CommentList;
